/*
 * @Descripttion:
 * @Author: 老板说这个需求很简单
 * @Date: 2025-05-26 19:14:02
 * @LastEditTime: 2025-06-11 13:44:42
 * @LastEditors: sudo_rm_rf
 */

import { DirectiveBinding, ref, VNode } from 'vue';
export default {
  mounted(el: HTMLElement, binding: DirectiveBinding, vnode: VNode, prevVnode) {
    // console.log(binding);
    if (typeof binding.value !== 'function') {
      const compName = vNode.context.name;
      let warn = [`longpress:`]`provided expression '${binding.expression}' is not afunction, but has to be `;
      if (compName) {
        warn += `Found in component '${compName}'`;
      }
      console.warn(warn);
    }
    // 定义变量
    let pressTimer: any = null;
    // 定义函数处理程序
    // 创建计时器（ 1秒后执行函数 ）
    let start = (e) => {
      if (e.type === 'click' && e.button !== 0) {
        return;
      }
      if (pressTimer === null) {
        pressTimer = setTimeout(() => {
          // 执行函数
          handler();
        }, 1000);
      }
    };
    // 取消计时器
    let cancel = () => {
      // 检查计时器是否有值
      if (pressTimer !== null) {
        clearTimeout(pressTimer);
        pressTimer = null;
      }
    };
    // 运行函数
    const handler = (e) => {
      // 执行传递给指令的方法
      binding.value(e);
    };
    // 添加事件监听器
    el.addEventListener('mousedown', start);
    el.addEventListener('touchstart', start);
    // 取消计时器
    el.addEventListener('click', cancel);
    el.addEventListener('mouseout', cancel);
    el.addEventListener('touchend', cancel);
    el.addEventListener('touchcancel', cancel);
  },
};
